import { render, staticRenderFns } from "./BloodBank.vue?vue&type=template&id=369f28c6"
import script from "./BloodBank.vue?vue&type=script&lang=js"
export * from "./BloodBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports